import { styled } from "@mui/material";

import { barChartUpdate } from "./barChartUpdate";
import { BarChartData } from "./types";

import { HoverTooltip } from "../shared/components/HoverTooltip";
import { ResponsiveSVG } from "../shared/ResponsiveSVG";

const YAxisGroup = styled("g")(({ theme }) => ({
  fontSize: 12,
  color: theme.vars.palette.texts.neutral.subtle,
  "& > path": {
    display: "none",
  },
  "& > g > line": {
    stroke: theme.vars.palette.divider,
    opacity: 0.5,
  },
}));

const XAxisGroup = styled("g")(({ theme }) => ({
  fontSize: 12,
  color: theme.vars.palette.texts.neutral.subtle,
  "& > path, line": {
    stroke: theme.vars.palette.texts.neutral.subtle,
    strokeWidth: 1,
  },
}));

const BarsGroup = styled("g")(({ theme }) => ({
  "& rect.bar": {
    fill: theme.vars.palette.chart.general.turquoise,
  },
}));

const AverageLine = styled("line")(({ theme }) => ({
  fill: "none",
  strokeWidth: "1",
  strokeDasharray: "4,4",
  stroke: theme.vars.palette.chart.general.orange,
}));

const SideBar = styled("rect")(({ theme }) => ({
  fill: theme.vars.palette.background.paper,
}));

type BarChartProps = {
  data: BarChartData;
};

export const BarChart = ({ data }: BarChartProps) => {
  return (
    <ResponsiveSVG
      chartUpdate={barChartUpdate}
      data={data}
      tooltip={<HoverTooltip className={"tooltip"} />}
    >
      <BarsGroup className={"bars"} />
      <AverageLine className={"average"} />
      <g className={"sideBars"}>
        <SideBar className={"left"} />
        <SideBar className={"right"} />
      </g>
      <YAxisGroup className={"yAxis"} />
      <XAxisGroup className={"xAxis"} />
    </ResponsiveSVG>
  );
};
